<div class="boondocking-poi-card">
  <div class="boondocking-poi-outer">
    <div>
      <div class="boondocking-poi-info-outer">
        <div class="trip-planner-image" [ngStyle]="{ 'background-image': 'url(' + photoUrl + ')' }"></div>
        <div class="boondocking-poi-info-inner">
          <div class="poi-boondocking-name-inner">
            <div class="site-name">{{ userPoint?.name }}</div>
            <div class="location-copy" *ngIf="userPoint?.coordinates">
              {{ userPoint.coordinates?.lat }}, {{ userPoint.coordinates?.lon }}
            </div>
          </div>
        </div>
      </div>
      <div class="poi-add-fav-outer">
        <div class="favorite-outer" (click)="onEdit()">
          <ion-icon name="pencil"></ion-icon>
        </div>
        <div class="favorite-outer" (click)="onRemove()">
          <ion-icon name="trash"></ion-icon>
        </div>
        <div class="cnt-button trip" (click)="onAddToTrip($event)">
          <div class="cnt-button-icon">
            <div class="html-embed w-embed">
              <curbnturf-site-svgs type="rvtrip"></curbnturf-site-svgs>
            </div>
          </div>
          <div class="cnt-button-copy">Add To Trip</div>
        </div>
      </div>
    </div>
  </div>
</div>
